import { Controller } from "@hotwired/stimulus"

// Assigning locations to an enterprise's shared Twilio registration. In edit
// mode it asks for an area code for locations being assigned, flags locations
// that will be unassigned, and confirms releasing their numbers before saving.
export default class extends Controller {
  static targets = ["checkbox"]

  connect() {
    this.update()
  }

  update() {
    this.checkboxTargets.forEach((checkbox) => {
      const row = checkbox.closest("tr")
      const removing = this.#removing(checkbox)
      const note = row.querySelector("[data-removal-note]")
      if (note) note.hidden = !removing
      const unlink = row.querySelector("[data-unlink]")
      if (unlink) unlink.disabled = !removing

      const areaCode = row.querySelector("[data-area-code]")
      if (areaCode) {
        const adding = checkbox.checked && !this.#saved(checkbox)
        areaCode.hidden = !adding
        areaCode.querySelector("input").disabled = !adding
        row.querySelector("[data-area-code-blank]").hidden = adding
      }
    })

    const removals = this.checkboxTargets.filter((checkbox) => this.#removing(checkbox)).length
    const dataset = this.element.dataset

    if (removals > 0) {
      const one = removals === 1
      dataset.body = `You are about to remove ${removals} location${one ? "" : "s"} from this campaign. ${one ? "Its phone number" : "Their phone numbers"} will stop working for ${one ? "it" : "them"} but stay bought in Twilio until someone releases ${one ? "it" : "them"}. Are you sure you want to continue?`
      dataset.button = "Remove"
      dataset.style = "destructive"
      dataset.turboConfirm = "Remove from Campaign"
    } else {
      delete dataset.body
      delete dataset.button
      delete dataset.style
      delete dataset.turboConfirm
    }
  }

  #removing(checkbox) {
    return this.#saved(checkbox) && !checkbox.checked
  }

  #saved(checkbox) {
    return checkbox.dataset.saved === "true"
  }
}
